var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "home-overlay decorative-elements decorative-elements__in-home-overlay"
    },
    [
      _c("div", { staticClass: "home-overlay--wrapper" }, [
        _c("div", { staticClass: "home-overlay--category-list" }, [
          _c("div", { staticClass: "home-overlay--category-wrapper" }, [
            _c(
              "div",
              { staticClass: "home-overlay--category-items" },
              _vm._l(_vm.categories, function(category) {
                return _c(
                  "div",
                  {
                    key: category.id,
                    staticClass: "home-overlay--category-item",
                    class: _vm.getCategoryItemClasses(category)
                  },
                  [
                    _c("category-menu-btn", {
                      staticClass: "home-overlay--category-menu-btn",
                      attrs: {
                        color: category.color,
                        image: category.image,
                        title: category.title,
                        type: category.type,
                        facets: ["home-overlay"]
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onCategorySelected($event, category)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "home-overlay--introduction" }, [
          _c(
            "div",
            { staticClass: "home-overlay--content" },
            [
              _c("h1", { staticClass: "u-reset home-overlay--title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("translate")("HOME_OVERLAY.TITLE")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("snake-pattern", {
                staticClass: "decorative-elements--snake-pattern"
              }),
              _vm._v(" "),
              _c("p", { staticClass: "u-reset home-overlay--text" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("translate")("HOME_OVERLAY.LEAD")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "decorative-elements--spacer" },
                [
                  _c("ui-icon", {
                    staticClass: "decorative-elements--spacer-icon",
                    attrs: { symbol: "rhomb", size: "medium" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "decorative-elements--cta" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "decorative-elements--cta-btn btn btn__primary btn__medium btn__uppercase",
                      attrs: { to: _vm.ctaLink }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm._f("translate")("HOME_OVERLAY.CTA_LABEL")
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "home-overlay--secondary-action" }, [
                _c(
                  "a",
                  {
                    staticClass: "home-overlay--secondary-action-btn",
                    attrs: { href: _vm.activeRootCategory.url }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("translate")(
                            "HOME_OVERLAY.SECONDARY_ACTION_LABEL"
                          )
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a1f9f16", { render: render, staticRenderFns: staticRenderFns })
  }
}